import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { ErrorBoundary } from '@sainsburys-tech/bolt'
import { agnostify } from '@sainsburys-tech/boltui-utils'
import LazyHydrate from 'react-lazy-hydration'

import { loadHomepageData as loadHomepageDataAction } from '../../actions/homepageAppActions'
import HomepageComponents from '../../components/HomepageComponents/HomepageComponents'
import AppPrompt from '../../components/AppPrompt/AppPrompt'
import ArgosCardPrompt from '../../components/ArgosCardPrompt/ArgosCardPrompt'
import EmailForm from '../../components/EmailForm/EmailForm'
import StoreLocator from '../../components/StoreLocator/StoreLocator'
import Recommendations from '../../components/Recommendations/Recommendations'
import FeaturedProducts from '../../components/FeaturedProducts/FeaturedProducts'
import PageNotFoundWrapper from '../../components/PageNotFoundWrapper/PageNotFoundWrapper'
import SeoHomepage from '../../components/SeoHomepage/SeoHomepage'
import { validAjaxLink } from '../../helpers/ContentHelper'

export class HomepageContainer extends Component {
  constructor(props) {
    super(props)
    this.onCmsClick = this.onCmsClick.bind(this)
  }

  componentDidMount() {
    const { homepageData, historyData, loadHomepageData } = this.props
    if (!homepageData.data) loadHomepageData({ resetData: true, historyData })
  }

  componentDidUpdate(prevProps) {
    const { history, historyData, loadHomepageData } = this.props
    const {
      location: { pathname: previousPathname },
    } = prevProps

    if (history.location.pathname !== previousPathname) {
      loadHomepageData({ resetData: true, historyData })
    }
  }

  onCmsClick(event, linkUrl) {
    if (!linkUrl || !linkUrl.includes('argos.co.uk')) return
    const ajaxLinkUrl = validAjaxLink(linkUrl)
    if (ajaxLinkUrl) {
      event.preventDefault()
      const { history } = this.props
      history.push(ajaxLinkUrl)
    } else window.location.href = agnostify(linkUrl)
  }

  render() {
    const { homepageData } = this.props
    const isHomepage404 = !homepageData
    if (isHomepage404) return <PageNotFoundWrapper />

    return (
      <>
        <h1 className='sr-only'>Argos Homepage</h1>
        <LazyHydrate whenIdle>
          <>
            <ErrorBoundary>
              <HomepageComponents
                homepageData={homepageData}
                isResettingData={homepageData && homepageData.resettingData}
                onCmsClick={this.onCmsClick}
              />
            </ErrorBoundary>
          </>
        </LazyHydrate>

        <LazyHydrate whenIdle>
          <>
            <ErrorBoundary>
              <FeaturedProducts />
            </ErrorBoundary>

            <ErrorBoundary>
              <EmailForm />
            </ErrorBoundary>
            <ErrorBoundary>
              <ArgosCardPrompt onCmsClick={this.onCmsClick} />
            </ErrorBoundary>
          </>
        </LazyHydrate>

        <LazyHydrate whenIdle>
          <ErrorBoundary>
            <AppPrompt />
          </ErrorBoundary>
        </LazyHydrate>

        <LazyHydrate whenIdle>
          <ErrorBoundary>
            <Recommendations />
          </ErrorBoundary>
        </LazyHydrate>

        <LazyHydrate whenVisible>
          <>
            <ErrorBoundary>
              <StoreLocator />
            </ErrorBoundary>
          </>
        </LazyHydrate>

        <LazyHydrate whenIdle>
          <ErrorBoundary>
            <SeoHomepage seoFooter={homepageData?.meta && homepageData?.meta?.seoFooter} />
          </ErrorBoundary>
        </LazyHydrate>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  homepageData: state?.homepageApp?.homepageData,
  historyData: state?.homepageApp?.historyData,
})

const mapDispatchToProps = (dispatch) => ({
  loadHomepageData: (params) => dispatch(loadHomepageDataAction(params)),
  push,
})

HomepageContainer.propTypes = {
  homepageData: PropTypes.arrayOf(PropTypes.object),
  historyData: PropTypes.objectOf(PropTypes.object),
  loadHomepageData: PropTypes.func.isRequired,
  history: PropTypes.shape({
    location: PropTypes.string,
    pathname: PropTypes.string,
    push: PropTypes.func,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
}

HomepageContainer.defaultProps = {
  homepageData: [],
  historyData: {},
}

export default connect(mapStateToProps, mapDispatchToProps)(HomepageContainer)
